import { ClickAwayListener } from "@nova/component-click-away-listener"
import classNames from "classnames"
import { memo } from "react"

export type SecondaryFlyoutMenuContentItem = {
    id: string
    title: string
    onClick: (id: string) => void
    isSelected?: boolean
}

const SecondaryFlyoutMenu = memo(
    ({
        items,
        onBlur,
        className,
    }: {
        items: SecondaryFlyoutMenuContentItem[]
        onBlur: () => void
        className?: string
    }) => {
        return (
            <ClickAwayListener
                onClickAway={onBlur}
                className={classNames(
                    "bg-gray-700 p-1 rounded-xl z-50 shadow-context-menu cursor-default select-none",
                    className
                )}
            >
                {items.map((item, i) => (
                    <div
                        key={i}
                        className="rounded-lg px-3 h-8 flex items-center hover:bg-gray-500 group cursor-pointer"
                        onClick={() => {
                            onBlur()
                            item.onClick(item.id)
                        }}
                    >
                        <small
                            className={classNames({
                                "text-gray-0": item.isSelected,
                                "text-gray-200 group-hover:text-gray-0": !item.isSelected,
                            })}
                        >
                            {item.title}
                        </small>
                    </div>
                ))}
            </ClickAwayListener>
        )
    }
)
SecondaryFlyoutMenu.displayName = "SecondaryFlyoutMenu"
export { SecondaryFlyoutMenu }
